import {
  GET_DDT_SUCCESS,
  GET_DDT_FAILED,
  GET_DDT_INVALID_WALLET_ID,
  GET_DDT_INVALID_TOKEN,
  RESET_GET_DDT,
  LOADING_GET_DDT,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  notFound: false,
  invalidToken: false,
  status: "",
  divisionList: [],
  districtList: [],
  thanaList: [],
  unionList: [],
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GET_DDT:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        notFound: false,
        invalidToken: false,
        status: "",
        networkError: "",
      };
    case GET_DDT_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        notFound: false,
        invalidToken: false,
        status: action.payload.status,
        networkError: "",
      };

    case GET_DDT_INVALID_TOKEN:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        notFound: false,
        invalidToken: true,
        status: action.payload.status,
        networkError: "",
      };

    case GET_DDT_INVALID_WALLET_ID:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        notFound: true,
        invalidToken: false,
        status: action.payload.status,
        networkError: "",
      };
    case GET_DDT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        notFound: false,
        invalidToken: false,
        divisionList: action.payload.divisionList || state.divisionList,
        unionList: action.payload.unionList || state.unionList,
        districtList: action.payload.districtList || state.districtList,
        thanaList: action.payload.thanaList || state.thanaList,
        networkError: "",
      };
    }

    case RESET_GET_DDT:
      return (state = initialState);

    default:
      return state;
  }
};
